module.exports = __webpack_public_path__ + "img/Giordano Immobilier_Accueil en haut.378ed9b9.jpg";